import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT to every request
api.interceptors.request.use(
  (cfg) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
  },
  (err) => Promise.reject(err)
);

// Handle 401 — try refresh, otherwise redirect to login
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    // ✅ KEY FIX: If this is the LOGIN request itself, NEVER redirect
    // Just reject and let LoginPage catch block handle it
    if (originalRequest.url?.includes('/auth/login/')) {
      return Promise.reject(err);
    }

    // Skip refresh if this IS the refresh request (avoid infinite loop)
    if (
      err.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes('/auth/refresh/')
    ) {
      const refresh = localStorage.getItem('refresh_token');
      if (refresh) {
        originalRequest._retry = true;
        try {
          const { data } = await axios.post(
            `${config.API_URL}/auth/refresh/`,
            { refresh }
          );
          localStorage.setItem('access_token', data.access);
          originalRequest.headers.Authorization = `Bearer ${data.access}`;
          return api(originalRequest);
        } catch {
          // Refresh failed — clear tokens and go to login
          localStorage.clear();
          window.location.href = '/login';
          return Promise.reject(err);
        }
      } else {
        // No refresh token — go to login
        localStorage.clear();
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;